import { apiClient } from './client';
import type {
  Administrator,
  CreateAdministratorData,
  UpdateAdministratorData,
  AdministratorResponse,
} from '@/types/administrator';

export async function getAdministrators(): Promise<Administrator[]> {
  const response = await apiClient.get<Administrator[]>('/api/administrators');
  return response.data;
}

export async function getAdministrator(id: number): Promise<Administrator> {
  const response = await apiClient.get<Administrator>(`/api/administrators/${id}`);
  return response.data;
}

export async function createAdministrator(
  data: CreateAdministratorData
): Promise<AdministratorResponse> {
  const response = await apiClient.post<AdministratorResponse>('/api/administrators', data);
  return response.data;
}

export async function updateAdministrator(
  id: number,
  data: UpdateAdministratorData
): Promise<AdministratorResponse> {
  const response = await apiClient.put<AdministratorResponse>(`/api/administrators/${id}`, data);
  return response.data;
}

export async function deleteAdministrator(id: number): Promise<{ message: string }> {
  const response = await apiClient.delete<{ message: string }>(`/api/administrators/${id}`);
  return response.data;
}
